import React,{useState} from 'react'

const Placement_2023 = ({data}) => {


  const [value, setValue] = useState();

  const handleChange = (e) => {
    setValue(e.target.value);
  };
  let uniqueList = [ ...new Set(data.map((currElem)=>{return currElem.Company;}))];
  uniqueList =uniqueList.sort();



    const newdata = data.filter((curr)=>{
      if(value === "All")
      {
        return data;
      }
      return curr.Company == value;
    })



  return (
<div>
    <div >
       
    <select class="test-div" style={{width:'800px',textTransform:'uppercase'}} value={value} onChange={handleChange}>
       <option className='mycomp' disabled selected value > -- Select a Company -- </option>
       <option className='mycomp' value="All">All Companies</option>
         {
           uniqueList.map((cur)=>{
             return (<option className='mycomp' value={cur}>{cur}</option>)
           })
         }
    </select>
   </div>
   <br />

   


    <div className='cardofstd'>
    {
      newdata.map((currElem)=>{
        var imageUrl = `../images/2023/${currElem.Roll}.webp`;
          const mailUrl = `mailto:${currElem.Mail}`

          return (
               <div className='person'>

                  <div class="container card_box">
                      <div class="row card_box_in">
                          <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                              <div class="our-team4">
                                <div class="picture">
                                  <img class="img-fluid" src={imageUrl}/>
                                </div>
                                <div class="team-content">
                                  <h4 class="name" style={{textTransform:"capitalize"}}>{currElem.Name}</h4>
                                  
                                  <h5 class="title">{currElem.Roll}</h5>
                               <br />
                                  <h5 class="name">-: Company :- </h5>
                                 <a href={currElem.Website} target='_blank'><h5 class="title" style={{textTransform:"capitalize"}}>{currElem.Company} </h5></a> 
                                 <br />
                                 <h5 class="name">-: Role :- </h5>
                        <h5 class="title" style={{textTransform:"capitalize"}}>{currElem.Role} </h5>
                                </div>
                                <br />

                                <ul class="social">
                                  
                                  <li><a href={mailUrl} class="fa fa-envelope" aria-hidden="true" target="_blank"></a></li>
                                  <li><a href={currElem.Linkedin} class="fa fa-linkedin" aria-hidden="true" target="_blank"></a></li>
                                </ul>
                              </div>
                            </div>
                            
                      </div>
                </div>

            </div>
            
          )
      })
    }
  </div>
  </div>
  )
}

export default Placement_2023